import React, { useRef, useState } from 'react';
import NDVIChart from '../Monitoring/NDVIChart';
import {
    GoogleMap,
    useLoadScript,
    Marker,
    Polygon,
    InfoWindow
} from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '600px'
};

const defaultCenter = { lat: 22.5937, lng: 78.9629 };

export const AgriFieldMaping = () => {
    const inputRef = useRef();
    const polygonRef = useRef();

    const [center, setCenter] = useState(defaultCenter);
    const [marker, setMarker] = useState(null);
    const [clickedMarker, setClickedMarker] = useState(null);
    const [polygonPath, setPolygonPath] = useState([]);
    const [fieldId, setFieldId] = useState(null);
    const [amedData, setAmedData] = useState(null);
    const [infoWindowPos, setInfoWindowPos] = useState(null);
    const [clickedAddress, setClickedAddress] = useState('');
    const [mapType, setMapType] = useState("satellite"); 
    const [selectedMarker, setSelectedMarker] = useState(null);

    const { isLoaded } = useLoadScript({
         googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyC16Y-R8bhKWx57M63qEGelyGB3SRfxFIU"
        //googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyDmmBMzFbZmGwc3FMR90OQNy8K3WFFK9eU"
    });

    // 1. Search location
    const handleSearch = async () => {
        const place = inputRef.current.value;
        alert(place);
        if (!place) return alert("Enter address");
        const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyC16Y-R8bhKWx57M63qEGelyGB3SRfxFIU";
        //const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyDmmBMzFbZmGwc3FMR90OQNy8K3WFFK9eU";
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(place)}&key=${apiKey}`;
        const response = await fetch(url);
        const data = await response.json();
        //alert(data.results.length);
        if (data.status === "OK" && data.results.length > 0) {
            const location = data.results[0].geometry.location;
            //alert(location);
            setCenter(location);
            setMarker(location);
        } else {
            alert("Location not found");
        }
    };

    // 2. Click map → get location, reverse geocode, ALU, AMED
    const handleMapClick = async (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        const clicked = { lat, lng };

        setClickedMarker(clicked);
        setCenter(clicked);
        setInfoWindowPos(clicked);
        setClickedAddress("Loading...");

        // Reverse Geocode using Google API
        try {
            const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyC16Y-R8bhKWx57M63qEGelyGB3SRfxFIU";
            //const apiKey = process.env.REACT_APP_GOOGLE_API_KEY || "YOUR_KEY_HERE";
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === "OK" && data.results.length > 0) {
                // google return results that include "plus_code","street_address", "locality", "premise", etc.
                //const fullAddress = data.results.find(r =>
                //    r.formatted_address && !r.formatted_address.startsWith("Unnamed Road")
                //);

                //if (fullAddress) {
                //    setClickedAddress(fullAddress.formatted_address);
                //} else {
                //    setClickedAddress("Address not found");
                //}

                // avoid plus_code
                //const validResult = data.results.find(r =>
                //    !r.formatted_address.includes("+") &&  // Avoid PXVC+23G style
                //    !r.types.includes("plus_code") &&      // Extra safe
                //    (
                //        r.types.includes("street_address") ||
                //        r.types.includes("route") ||
                //        r.types.includes("premise") ||
                //        r.types.includes("locality") ||
                //        r.types.includes("sublocality")
                //    )
                //);
                //const bestResult = data.results.find(
                //    r => !r.types.includes("plus_code")
                //);

                //if (validResult) {
                //    setClickedAddress(validResult.formatted_address);
                //}
                //else {
                //    setClickedAddress("Address not found");
                //}
               setClickedAddress(data.results[0].formatted_address);
            } else {
                setClickedAddress("Address not found1");
            }
        } catch (error) {
            setClickedAddress("Geocode failed");
        }

        // 🔁 Replace with real ALU
        const alu = await mockALU(lat, lng);
        setFieldId(alu.id);
        setPolygonPath(alu.geometry);

        // 🔁 Replace with real AMED
        const amed = await mockAMED(alu.id);
        setAmedData(amed);
    };

    // Polygon load
    const onPolygonLoad = (polygon) => {
        polygonRef.current = polygon;
    };

    // When polygon edited
    const handlePolygonEdit = () => {
        if (!polygonRef.current) return;

        const newPath = polygonRef.current
            .getPath()
            .getArray()
            .map(p => ({ lat: p.lat(), lng: p.lng() }));

        setPolygonPath(newPath);
        console.log("Updated Polygon:", newPath);
    };

    //  MOCK ALU
    const mockALU = async (lat, lng) => ({
        id: "MOCK_FIELD_123",
        geometry: [
            { lat: lat + 0.0003, lng: lng - 0.0003 },
            { lat: lat + 0.0003, lng: lng + 0.0003 },
            { lat: lat - 0.0003, lng: lng + 0.0003 },
            { lat: lat - 0.0003, lng: lng - 0.0003 }
        ]
    });

    // MOCK AMED
    const mockAMED = async (fieldId) => ({
        crop: "Rice",
        ndvi: 0.81,
        moisture: "Medium",
        lastUpdate: "2025-09-28",
        ndviHistory: [
            { date: "2025-08-01", ndvi: 0.52 },
            { date: "2025-08-08", ndvi: 0.58 },
            { date: "2025-08-15", ndvi: 0.61 },
            { date: "2025-08-22", ndvi: 0.70 },
            { date: "2025-08-29", ndvi: 0.74 },
            { date: "2025-09-05", ndvi: 0.76 },
        ],
    });


    /*
    ✅ Replace MOCK with Google Agri ALU API

    const getALUFieldID = async (lat, lng) => {
        const url = `https://agriculture.googleapis.com/v1/fields:searchByPoint?key=YOUR_API_KEY`;
        const body = {
            location: {
                latitude: lat,
                longitude: lng
            }
        };
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
                // "Authorization": "Bearer YOUR_ACCESS_TOKEN"
            },
            body: JSON.stringify(body)
        });
        const data = await response.json();
        if (!data.fields || data.fields.length === 0) return null;
        const field = data.fields[0];
        const geometry = field.geometry.linearRing.map(pt => ({
            lat: pt.latitude,
            lng: pt.longitude
        }));
        return {
            id: field.name.split("/").pop(),
            geometry
        };
    };
    */

    /*
    ✅ Replace MOCK with Google Agri AMED API

    const getAMEDMonitoring = async (fieldId) => {
        const projectId = "YOUR_PROJECT_ID";
        const fullFieldName = `projects/${projectId}/locations/global/fields/${fieldId}`;
        const url = `https://agriculture.googleapis.com/v1/projects/${projectId}/locations/global/fieldEvents:get?field=${encodeURIComponent(fullFieldName)}&key=YOUR_API_KEY`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
                // "Authorization": "Bearer YOUR_ACCESS_TOKEN"
            }
        });
        const data = await response.json();
        return {
            fieldId,
            cropType: data.cropType || "Unknown",
            cropStage: data.cropStage || "Unknown",
            ndvi: data.ndvi || 0,
            soilMoisture: data.soilMoisture || "Unknown",
            lastUpdated: data.lastUpdated || new Date().toISOString()
        };
    };
    */


    return (
        <div style={{ padding: 20 }}>
            <h3>🌾 Smart Agriculture Dashboard – Field Mapping & Monitoring</h3>
            <div style={{ marginBottom: 10 }} class="row">
                <div class="col">
                    <input
                        ref={inputRef}
                        type="text"
                        placeholder="Enter village, city, or coordinates"
                        style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "14px",
                            marginRight: "8px",
                            borderRadius: "4px",
                            border: "1px solid #ccc"
                        }}
                    />
                </div>
                <div class="col">
                    <button
                        onClick={handleSearch}
                        style={{
                            padding: "8px 12px",
                            fontSize: "14px",
                            backgroundColor: "#99cc22",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                    >
                        🔍 Search
                    </button>
                </div>


                <div class="col">
                    <button
                        onClick={() => setMapType("satellite")}
                        style={{
                            padding: "8px 10px",
                            fontSize: "14px",
                            backgroundColor: mapType === "satellite" ? "#2980b9" : "#bdc3c7",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                    >
                        🛰️ Satellite
                    </button>
                </div>
                <div class="col">
                    <button
                        onClick={() => setMapType("roadmap")}
                        style={{
                            padding: "8px 10px",
                            fontSize: "14px",
                            backgroundColor: mapType === "roadmap" ? "#2980b9" : "#bdc3c7",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                    >
                        🗺️ Roadmap
                    </button>
                </div>
            </div>
            {isLoaded ? (
                <div>
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={18}
                    onClick={handleMapClick}
                    mapTypeId={mapType}       
                >
                    {marker && <Marker position={marker} />}
                    {clickedMarker && <Marker position={clickedMarker} label="📍" />}

                    {/* Info Window */}
                    {infoWindowPos && (
                        <InfoWindow
                            position={infoWindowPos}
                            onCloseClick={() => setInfoWindowPos(null)}
                        >
                            <div>
                                <strong>📌 Address:</strong><br />
                                {clickedAddress}<br />
                                <small>Lat: {infoWindowPos.lat.toFixed(5)}<br />Lng: {infoWindowPos.lng.toFixed(5)}</small>
                            </div>
                        </InfoWindow>
                    )}

                    {/* Editable Polygon */}
                    {polygonPath.length > 0 && (
                        <Polygon
                            paths={polygonPath}
                            editable={true}
                            draggable={false}
                            onLoad={onPolygonLoad}
                            onMouseUp={handlePolygonEdit}
                            onDragEnd={handlePolygonEdit}
                            options={{
                                fillColor: '#00FF0088',
                                strokeColor: '#00FF00',
                                strokeWeight: 2
                            }}
                        />
                    )}
                </GoogleMap>
                 < div style = {{
    flex: 1,
        padding: "20px",
            backgroundColor: "#f4f6f8",
                border: "1px solid #ccc",
                    borderRadius: "8px",
                        height: "fit-content"
}}>
    <h3 style={{ color: "#2c3e50", marginBottom: "15px" }}>
        🛰️ Monitoring Panel
    </h3>
{ fieldId && <p><strong>Field ID:</strong> {fieldId}</p> }

                    {amedData && amedData.ndviHistory && (
                        <div style={{ marginTop: 20 }}>
                            <h5>NDVI Trend (Mock)</h5>
                            <NDVIChart ndviData={amedData.ndviHistory} />
                        </div>
                    )}


                    </div >
                </div>
            ) : (
                <p>Loading Map...</p>
            )}

            {/* Monitoring Info */}
            {fieldId && (
                <div style={{ marginTop: 20 }}>
                    <h4>🧾 Field ID: {fieldId}</h4>
                    <p>🌱 Crop: {amedData?.crop}</p>
                    <p>🌿 NDVI: {amedData?.ndvi}</p>
                    <p>💧 Soil Moisture: {amedData?.moisture}</p>
                    <p>🕒 Last Updated: {amedData?.lastUpdate}</p>
                </div>
            )}
        </div>
    );
};

export default AgriFieldMaping;
